import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { transformationUses } from '../../data/content';
export function TransformationSection() {
  return <section aria-labelledby="transformation-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-192" data-mp="3l7fzfguhiq24">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="3q4g9s3ydaez1">
        <SectionHeading id="transformation-heading" title={<>
              Imagine Opening Your Teaching Material and Having the Class <Accent data-id="element-195" data-mp="3g8cvjzq8qpvq">Already Structured.</Accent>
            </>} body="No wondering what comes next. No rebuilding the same explanations every time you teach. No creating every checklist, practice activity or assessment from zero." data-id="element-194" data-mp="3q3en127zo41h" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-x-12 border-t border-brand-charcoal/12 sm:grid-cols-2" role="list" data-id="element-196" data-mp="10gp42jtzxpkb">
          {transformationUses.map(use => <li key={use} className="flex items-start gap-3 border-b border-brand-charcoal/12 py-3.5 text-[15px] leading-snug text-brand-charcoal" data-id="element-197" data-mp="15dfotkgqx9c2">
              <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-198" data-mp="isfxuww0lves" />
              {use}
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-199" data-mp="ro5gwz9zqdp0">
          You bring your experience. <Accent data-id="element-200" data-mp="3w1u4yipm0yl0">Nail Educator Ready™</Accent> gives you the teaching structure.
        </p>
      </div>
    </section>;
}